// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;600&display=swap);"]);
// Module
exports.push([module.id, "*[data-v-4e667546]{box-sizing:border-box}html[data-v-4e667546]{font-size:15px}body[data-v-4e667546]{line-height:1.5;font-family:Poppins;font-size:.9rem;color:#707070;background-color:var(--app-bg-color);font-weight:400;letter-spacing:.4px}.active_tab[data-v-4e667546]{border-bottom:2px solid var(--lms-tenant);color:var(--lms-tenant)}", ""]);
// Exports
module.exports = exports;
